__webpack_require__.p = "/Math-Magicians/";